import { baseAxios, handleError } from 'api';
import { useMutation } from '@tanstack/react-query';

import useCredentials from 'api/hook/useCredentials';

/**
 * @typedef {import('yup').InferType<typeof import('../utils/orderUtil').OrderScheme>} TOrder
 */
/**
 * @return {import('@tanstack/react-query').UseMutationResult<TOrder, any, void, unknown>}
 */
export function useCreateAdminOrder() {
  const authAxios = useCredentials();

  return useMutation({
    mutationFn: (data) =>
      baseAxios(authAxios, {
        url: '/order/admin',
        method: 'post',
        data,
      }),
    onError: handleError,
  });
}
